<template>
  <div id="brain-images" :class="classes">
    <div v-for="n in 21" :key="n" class="brain-wrapper">
      <!-- <transition name="fade"> -->
        <img :src="getImgPath(n-1)" v-show="n-1 == year" :alt="altText[n-1]" />
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
import yearListenerMixin from '@/mixins/yearListenerMixin';
import progressionMixin from "@/mixins/progressionMixin";

export default {
  name: "BrainImages",
  props: ['classes'],
  mixins: [yearListenerMixin, progressionMixin],
  data() {
    return {
      altText: [
        'Typical T 2 weighted FLAIR axial slice of a brain M R I that appears healthy at this time point.',
        'T 2 weighted FLAIR Brain M R I showing numerous periventricular white matter hyperintensities consistent with possible M S plaques (Dawson’s fingers).',
        'T 2 weighted FLAIR brain M R I, showing light-colored hyperintensities (lesions) on both sides of brain. Lesions are more prominent than the previous year.',
        'T 2 weighted FLAIR brain M R I, showing white hyperintensities (lesions) on both sides of brain.',
        'T 2 weighted FLAIR brain M R I, showing light-colored hyperintensities (lesions) on both sides of brain. There are noticeably more lesions than previous year.',
        'T 2 weighted FLAIR brain M R I, showing light-colored hyperintensities (lesions) on both sides of brain.',
        'T 2 weighted FLAIR Brain M R I, showing diffuse light-colored hyperintensities near ventricles on both sides of brain.',
        'T 2 weighted FLAIR Brain MRI, showing light-colored hyperintensities near ventricles and enlarged ventricles. Periventricular volume loss is becoming more evident as the disease progresses.',
        'T 2 weighted FLAIR Brain M R I, showing atrophy of periventricular tissue in area of previous lesion.',
        'T 2 weighted FLAIR Brain M R I, showing brain with volume loss, including periventricular area.',
        'T 2 weighted Brain M R I, showing brain with lesions and progressing volume loss, including periventricular area.',
        'T 2 weighted Brain M R I, showing brain with lesions and volume loss, including periventricular area.',
        'T 2 weighted FLAIR Brain M R I, showing brain with lesions and volume loss.',
        'T 2 weighted FLAIR Brain M R I, showing brain with lesions and volume loss, increased from last image.',
        'T 2 weighted brain M R I, showing brain with evident volume loss.',
        'T 2 weighted FLAIR Brain M R I, showing brain with widespread lesions and volume loss.',
        'T 2 weighted FLAIR Brain M R I, showing brain with widespread lesions and volume loss.',
        'T 2 weighted brain M R I showing a brain with large periventricular lesions and volume loss.',
        'T 2 weighted FLAIR Brain M R I, showing brain with sizeable lesions and volume loss.',
        'T 2 weighted FLAIR Brain M R I, showing brain with sizeable lesions and volume loss. Lesions appear bigger in size than previous scan.',
        'T 2 weighted Brain M R I, showing brain with large ventricles and substantial volume loss.',
       ]
    }
  },

  methods : {
    getImgPath(index) {
      return require(`../assets/img/brains/brain_${index}.png`);
    }
  }
}
</script>

<style lang="scss">
  #brain-images {
    position: absolute;
    top: 50px;
    left: 200px;
    display: inline-block;
    width: 30%;
    @include breakpoint(lg) {
      width: 40%;
      top: 40px;
      left: 140px;
    }
    @include breakpoint(xs) {
      top: 20px;
      left: 140px;
    }
    @media (max-width: 600px) {
      left: 100px;
      top: 45px;
    }
    @media (max-width: 450px) {
      left: 75px;
      top: 50px;
    }
    .brain-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    &.relative {
      position: relative;
      top: 0;
      left: -150px;
      width: 150%;
      padding-right: rem(30px);
      @include breakpoint(lg) {
        width: 120%;
      }
      .brain-wrapper {
        position: relative;
        
      }
    }
  }
  #lesions-copy {
    margin-top: 30px;
    @include breakpoint(xs) {
      display: none;
    }
  }
</style>
